import { Component, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ChildrenSelectorComponent, Student } from '../../shared/children-selector/children-selector.component';
import { InfoenfantService, AllergieStudentModel } from '../../services/infoenfant.service';
import { PageTitleComponent } from '../../shared/page-title/page-title.component';
import { LoaderComponent } from "../../shared/loader/loader.component";
import { AlertService } from '../../services/alert.service';

interface EmergencyContact {
  id?: string;
  childRelative?: string;
  firstName?: string;
  lastName?: string;
  adress?: string;
  languParle?: string;
  familyStuation?: string;
  profession?: string;
  adressMail?: string;
  mobile?: string;
  emmergencyCall?: boolean;
  takeAfterSchool?: boolean;
}

@Component({
  selector: 'app-infoenfant',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ChildrenSelectorComponent,
    TranslatePipe,
    PageTitleComponent,
    LoaderComponent,
  ],
  templateUrl: './infoenfant.component.html',
  styleUrls: ['./infoenfant.component.css'],
})
export class InfoenfantComponent  {
  private readonly defaultAvatar = 'assets/default-avatar.jpg';

  activeTab: string = 'profil';
  selectedStudent: Student | null = null;
  loading = false;

  dataSubscription: any = null;

  profileForm = {
    nameStudent: '',
    arabicName: '',
    birthDate: '',
    birthPlace: '',
    batchName: '',
    admissionNumber: '',
    fatherPhone: '',
    fatherPhone2: '',
    gender: '',
    gradeId: '',
    batchId: '',
    nameOrg: '',
    photo: this.defaultAvatar,
  };

  selectedFile: File | null = null;
  // Images carousel
  images: string[] = [];
  selectedImageIndex: number = 0;
  currentImageIndex: number = 0;
  schoolForm = {
    oldJardinKind: false,
    haveBeenToPreparatoire: false,
    transfered: false,
    startingLevel: '',
    transfertReason: '',
    allowTripOcaPar: false,
    allowTripPermPar: false,
  };

familyForm = {
  father: {
    id:'',
    firstName: '',
    lastName: '',
    adress: '',
    languParle: '',
    familyStuation: '',
    profession: '',
    adressMail: '',
    mobile:'',
  },
  mother: {
    id:'',
    firstName: '',
    lastName: '',
    adress: '',
    languParle: '',
    familyStuation: '',
    profession: '',
    adressMail: '',
    mobile:'',
  },
  childrenNumber: '',
  childRank: '',
  liveWithParents: false,
  otherGuardian: '',
  emergencyContacts: [] as EmergencyContact[]
};

  healthForm: any = {
    // Behavior fields from mlrecoleRefFour
    playMode: 'Seul',
    games: '',
    behaviour: 'Calme',
    bigEater: 'non',
    eatServed: 'non',
    favouriteGames: '',
    napTaker: 'non',
    napTime: '',
    selfWearing: 'non',
    unwantedFood: '',
    cryAttitude: 'non',
    shyAttitude: 'non',
    meneur: 'non',
    introverti: 'non',
    nervous: 'non',
    irritManifest: '',
    notesDeComportement: '',
    dresseAllown: 'non',
    enjoyMeal: 'non',
    eatEvreything: 'non',
    aliments: 'oui',
    detestedMeal: '',
    // Health fields from mlrecole
    health: 'excellente',
    hospitalized: 'non',
    hospitalReason: '',
    hospitalAge: '',
    walkingAge: '',
    disease: '',
    dentalRecord: 'non',
    allergie: 'non',
    fever: 'non',
    convulsion: 'non',
    extraProblem: '',
    bloodType: '',
    nameOfDoctor: '',
    adressDoctor: '',
    vaccinScolaire: 'non'
  };

  allergyForm = {
    type: '',
  };

  // Allergy management
  allergiesList: AllergieStudentModel[] = [];
  selectedAllergies: number[] = [];
  availableAllergies: AllergieStudentModel[] = [];
  selectedNewAllergy: number | null = null;



  constructor(
    private infoenfantService: InfoenfantService,
    private cd: ChangeDetectorRef,
    private alertService: AlertService
  ) {}

  private getBatchNameFromStorage(batchId: number | string): string {
    try {
      const parsedBatchId = Number(batchId);
      if (!parsedBatchId) return '';

      const raw = localStorage.getItem('studentList');
      if (!raw) return '';

      const students = JSON.parse(raw) as any[];
      const match = students.find((item) => Number(item?.batchId) === parsedBatchId);

      return (
        match?.batch?.batchname ??
        match?.batchname ??
        match?.batchName ??
        ''
      );
    } catch {
      return '';
    }
  }

  onSubmitHealthData(): void {
    if (this.selectedStudent) {
      this.alertService.showConfirmation(
         { title: 'Confirmation', message: 'Êtes-vous sûr de vouloir enregistrer ces données de santé ?' }
       ).then((isConfirmed) => {
         if (isConfirmed) {
          const santeData = {
            playMode: this.healthForm.playMode,
            behaviour: this.healthForm.behaviour,
            cryAttitude: this.healthForm.cryAttitude === 'Oui',
            shyAttitude: this.healthForm.shyAttitude === 'Oui',
            games: this.healthForm.games,
            meneur: this.healthForm.meneur === 'Oui',
            introverti: this.healthForm.introverti === 'Oui',
            irritManifest: this.healthForm.irritManifest,
            notesDeComportement: this.healthForm.notesDeComportement,
            dresseAllown: this.healthForm.dresseAllown === 'Oui',
            enjoyMeal: this.healthForm.enjoyMeal === 'Oui',
            eatEvreything: this.healthForm.eatEvreything === 'Oui',
            aliments: this.healthForm.aliments,
            detestedMeal: this.healthForm.detestedMeal,
            health: this.healthForm.health,
            hospitalized: this.healthForm.hospitalized === 'Oui',
            hospitalReason: this.healthForm.hospitalReason,
            hospitalAge: this.healthForm.hospitalAge ? parseInt(this.healthForm.hospitalAge) : 0,
            walkingAge: this.healthForm.walkingAge ? parseInt(this.healthForm.walkingAge.replace(' an', '')) : 0,
            disease: this.healthForm.disease,
            dentalRecord: this.healthForm.dentalRecord === 'Oui',
            allergie: this.healthForm.allergie === 'Oui',
            fever: this.healthForm.fever === 'Oui',
            nervous: this.healthForm.nervous === 'Oui',
            convulsion: this.healthForm.convulsion === 'Oui',
            extraProblem: this.healthForm.extraProblem,
            vaccinScolaire: this.healthForm.vaccinScolaire === 'Oui',
            bloodType: this.healthForm.bloodType,
            nameOfDoctor: this.healthForm.nameOfDoctor,
            adressDoctor: this.healthForm.adressDoctor
          };

          if (!this.selectedStudent) return;
          this.infoenfantService.updateSante(this.selectedStudent.idStudent.toString(), santeData).subscribe({
            next: (response) => {
              this.alertService.showSuccess({ title: 'Succès', message: 'Données de santé mises à jour avec succès' });
            },
            error: (error) => {
              // console.error('Error updating health data:', error);
              this.alertService.showError({ title: 'Erreur', message: 'Veuillez remplir tous les champs obligatoires.' });
            }
          });
        }
      });
    }
  }

onSubmitAllergy(): void {
  if (!this.selectedStudent) return; // ✅ protection au début

  this.alertService.showConfirmation({
    title: 'Confirmation',
    message: 'Êtes-vous sûr de vouloir enregistrer ces données d\'allergie ?'
  }).then(isConfirmed => {
    if (!isConfirmed || !this.selectedStudent) return;

    // ✅ utilisation de l'opérateur "!" pour dire à TS qu’on a déjà vérifié
    const batchId = Number(this.selectedStudent!.batchId);
    const studentId = Number(this.selectedStudent!.idStudent);
    const orgId = Number(this.selectedStudent!.idOrg);

    if (!batchId || !studentId || !orgId) {
      this.alertService.showError({
        title: 'Erreur',
        message: 'Identifiants invalides pour l\'envoi des données.'
      });
      return;
    }

    // ✅ pas d’accès direct à baseUrl car elle est private
    const debugUrl = `/api/allergieCantine/update/${batchId}/${studentId}/${orgId}`;
    console.log('POST URL:', debugUrl);

    this.infoenfantService.setAllergie(batchId, studentId, orgId, this.selectedAllergies)
      .subscribe({
        next: (res) => {
          console.log('Réponse API allergie:', res);
          this.alertService.showSuccess({
            title: 'Succès',
            message: 'Données d\'allergie mises à jour avec succès'
          });
          this.loadAllergieData();
        },
        error: (err) => {
          console.error('Erreur maj allergie:', err);
          this.alertService.showError({
            title: 'Erreur',
            message: 'Erreur lors de la mise à jour des données d\'allergie'
          });
        }
      });
  });
}



  // Load allergy data for the selected student
loadAllergieData(): void {
  if (!this.selectedStudent) return;

  const { idStudent, idOrg, batchId } = this.selectedStudent;

  this.infoenfantService
    .getAllergieByStudentId(idStudent, idOrg, batchId)
    .subscribe({
      next: (res) => {
        if (res && res.response) {
          const allergies: { id: number; nomFr: string; nomAr: string; selected: string }[] = res.response;

          this.allergiesList = allergies.filter((allergy: any) => allergy.selected === '1');
          this.selectedAllergies = this.allergiesList.map((allergy: any) => allergy.id);
          this.availableAllergies = allergies.filter((allergy: any) => allergy.selected === '0');
        } else {
          this.allergiesList = [];
          this.selectedAllergies = [];
          this.availableAllergies = [];
        }
      },
      error: (err) => {
        console.error('Erreur lors du chargement des allergies:', err);
      },
    });
}


  // Delete allergy
  deleteAllergy(allergyId: number): void {
    this.alertService.showDeleteConfirmation({ title: 'Confirmation de suppression', message: 'Êtes-vous sûr de vouloir supprimer cette allergie ?' }).then((isConfirmed) => {
       if (isConfirmed) {
        // Remove from selected allergies
        this.selectedAllergies = this.selectedAllergies.filter(id => id !== allergyId);
        // Remove from allergies list
        const removedAllergy = this.allergiesList.find(allergy => allergy.id === allergyId);
        this.allergiesList = this.allergiesList.filter(allergy => allergy.id !== allergyId);
        // Add back to available allergies if found
        if (removedAllergy) {
          this.availableAllergies.push(removedAllergy);
        }
       }
    });
  }

  // Add new allergy
  onAllergySelected(allergyId: any): void {
    if (allergyId && allergyId !== '') {
      const allergyToAdd = this.availableAllergies.find(allergy => allergy.id == allergyId);
      if (allergyToAdd) {
        // Add to selected allergies
        this.allergiesList.push(allergyToAdd);
        this.selectedAllergies.push(allergyToAdd.id);
        // Remove from available allergies
        this.availableAllergies = this.availableAllergies.filter(allergy => allergy.id != allergyId);
        // Reset selection
        this.selectedNewAllergy = null;
      }
    }
  }

  addAllergy(): void {
    if (this.selectedNewAllergy) {
      const allergyToAdd = this.availableAllergies.find(allergy => allergy.id === this.selectedNewAllergy);
      if (allergyToAdd) {
        // Add to selected allergies
        this.allergiesList.push(allergyToAdd);
        this.selectedAllergies.push(allergyToAdd.id);
        // Remove from available allergies
        this.availableAllergies = this.availableAllergies.filter(allergy => allergy.id !== this.selectedNewAllergy);
        // Reset selection
        this.selectedNewAllergy = null;
        // Update backend immediately
        this.onSubmitAllergy();
      }
    }
  }

  // Conditional display methods
  onNervousChange(): void {
    if (this.healthForm.nervous !== 'oui') {
      this.healthForm.irritManifest = '';
    }
  }

  onAlimentsChange(): void {
    if (this.healthForm.aliments !== 'non') {
      this.healthForm.detestedMeal = '';
    }
  }

  onHospitalizedChange(): void {
    if (this.healthForm.hospitalized !== 'oui') {
      this.healthForm.hospitalReason = '';
      this.healthForm.hospitalAge = '';
    }
  }

  showNervousDetails(): boolean {
    return this.healthForm.nervous === 'oui';
  }

  showAlimentsDetails(): boolean {
    return this.healthForm.aliments === 'oui';
  }

  showHospitalDetails(): boolean {
    return this.healthForm.hospitalized === 'oui';
  }

  loadHealthData(): void {
    if (this.selectedStudent) {
      // Load health data (santé)
      this.infoenfantService.getSanteByStudentId(this.selectedStudent.idStudent.toString()).subscribe({
        next: (santeResponse) => {
          if (santeResponse && santeResponse.mlrecole) {
            const healthData = santeResponse.mlrecole;
            this.healthForm.hospitalAge = healthData.hospitalAge?.toString() || '';
            this.healthForm.hospitalized = healthData.hospitalized ? 'oui' : 'non';
            this.healthForm.walkingAge = healthData.walkingAge?.toString() || '';
            this.healthForm.vaccinScolaire = healthData.vaccinScolaire ? 'oui' : 'non';
          }
        },
      });

      // Load behavior data (comportement)
    this.infoenfantService.getComportementByStudentId(Number(this.selectedStudent.idStudent)).subscribe({
  next: (comportementResponse) => {
    if (comportementResponse && comportementResponse.response) {
      const behaviorData = comportementResponse.response;

      // Map comportement data to health form using actual backend field names
      this.healthForm.enjoyMeal = behaviorData.bigEater ? 'oui' : 'non';
      this.healthForm.cryAttitude = behaviorData.cryAttitude ? 'oui' : 'non';
      this.healthForm.eatEvreything = behaviorData.eatServed ? 'oui' : 'non';
      this.healthForm.games = behaviorData.favouriteGames || '';
      this.healthForm.introverti = behaviorData.introverti ? 'oui' : 'non';
      this.healthForm.irritManifest = behaviorData.irritManifest || '';
      this.healthForm.meneur = behaviorData.meneur ? 'oui' : 'non';
      this.healthForm.nervous = behaviorData.nervous === 'true' ? 'oui' : 'non';
      this.healthForm.notesDeComportement = behaviorData.notesDeComportement || '';
      this.healthForm.dresseAllown = behaviorData.selfWearing ? 'oui' : 'non';
      this.healthForm.shyAttitude = behaviorData.shyAttitude ? 'oui' : 'non';
      this.healthForm.detestedMeal = behaviorData.unwantedFood || '';
    }
  },
  error: (error) => {
    console.error('Error loading comportement data:', error);
  }
});

    }
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
  }

  resetForm(): void {
    this.profileForm = {
      nameStudent: '',
      arabicName: '',
      birthDate: '',
      birthPlace: '',
      batchName: '',
      admissionNumber: '',
      fatherPhone: '',
      fatherPhone2: '',
      gender: '',
      gradeId: '',
      batchId: '',
      nameOrg: '',
      photo: this.defaultAvatar,
    };
    this.selectedStudent = null;
    this.selectedFile = null;
  }

  onStudentSelected(student: Student): void {
    // Réinitialiser le formulaire avant de charger de nouvelles données
    this.resetForm();

    this.selectedStudent = student;

    // Stocker l'ID de l'étudiant dans le localStorage pour persistance
    localStorage.setItem('lastSelectedStudentId', student.idStudent.toString());

    // Forcer Angular à détecter le changement
    this.cd.detectChanges();

    this.loading = true;
    this.loadSchoolData();
    this.loadFamilyData();
    this.loadHealthData();
    this.loadAllergieData();
    const timestamp = new Date().getTime();

    // Annuler tout abonnement précédent pour éviter les conflits
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }

    this.dataSubscription = this.infoenfantService
      .getStudentProfileNoCache(
        student.idStudent.toString(),
        student.idUserStudent.toString(),
        student.idOrg.toString(),
        student.batchId.toString()
      )
      .subscribe({
        next: (data: any) => {
          // Handle photo data - check if it's base64 or URL
          let photoUrl = this.defaultAvatar;
          const photoData = (data.photo ?? student.photo ?? '').toString().trim();
          if (photoData && photoData.toLowerCase() !== 'null' && photoData.toLowerCase() !== 'undefined') {
            if (photoData.startsWith('data:image')) {
              photoUrl = photoData;
            } else if (
              photoData.startsWith('/9j') ||
              photoData.startsWith('iVBOR') ||
              photoData.length > 100
            ) {
              // Assume it's base64 data
              photoUrl = `data:image/jpeg;base64,${photoData}`;
            } else {
              // It might be a URL or path
              photoUrl = photoData;
            }
          }

          const firstFatherPhone =
            Array.isArray(data.numpere) && data.numpere.length > 0
              ? data.numpere[0].usercode || ''
              : typeof data.numpere === 'string'
              ? data.numpere
              : '';

          const secondFatherPhone =
            Array.isArray(data.numpere) && data.numpere.length > 1
              ? data.numpere[1].usercode || ''
              : data.deuxiemnumpere || '';

          const lastName = (data.nom ?? data.lastName ?? '').toString();
          const firstName = (data.prenom ?? data.firstName ?? '').toString();
          const fullName =
            `${lastName} ${firstName}`.trim() || student.nameStudent || '';

          const resolvedBatchName =
            data.batch?.batchname ??
            data.batchname ??
            data.batchName ??
            (student as any).batch?.batchname ??
            (student as any).batchname ??
            (student as any).batchName ??
            this.getBatchNameFromStorage(data.batchId ?? student.batchId) ??
            '';

          this.profileForm = {
            nameStudent: fullName,
            arabicName:
              data.arabename ?? data.arabeName ?? student.arabicName ?? '',
            birthDate:
              (data.datenais ?? data.birthDateString ?? '')
                .toString()
                .split('T')[0] ||
              student.birthDate ||
              '',
            birthPlace:
              data.lieunais ?? data.birthPlace ?? student.birthPlace ?? '',
            batchName: resolvedBatchName,
            admissionNumber:
              data.admissionNumber?.toString() ||
              student.digiref?.toString() ||
              '',
            fatherPhone: firstFatherPhone,
            fatherPhone2: secondFatherPhone,
            gender: data.gender || student.gender || '',
            gradeId:
              data.gradeId?.toString() || student.gradeId?.toString() || '',
            batchId:
              data.batchId?.toString() || student.batchId?.toString() || '',
            nameOrg: data.nameOrg || student.nameOrg || '',
            photo: photoUrl,
          };

          this.cd.detectChanges();
          this.loading = false;
        },
        error: (err) => {
          console.error('Erreur de chargement du profil:', err);
          const fallbackPhoto = (student.photo || '').toString().trim();
          this.profileForm.photo =
            fallbackPhoto &&
            fallbackPhoto.toLowerCase() !== 'null' &&
            fallbackPhoto.toLowerCase() !== 'undefined'
              ? fallbackPhoto
              : this.defaultAvatar;
          this.loading = false;
        },
      });
  }

  onAvatarError(event: Event): void {
    const img = event.target as HTMLImageElement | null;
    if (!img) return;

    if (img.src.endsWith(this.defaultAvatar)) {
      return;
    }

    img.src = this.defaultAvatar;
    this.profileForm.photo = this.defaultAvatar;
  }

  triggerFileInput(): void {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    fileInput?.click();
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      if (!file.type.startsWith('image/')) {
        this.alertService.showError({ title: 'Error', message: 'Please select a valid image file' });
        return;
      }

      this.selectedFile = file;

      // Preview the selected image
      const reader = new FileReader();
      reader.onload = () => {
        this.profileForm.photo = reader.result as string;
        this.cd.detectChanges();
      };
      reader.readAsDataURL(file);
    }
  }

// composant : infoenfant.component.ts
uploadPhoto(): void {
  if (!this.selectedFile || !this.selectedStudent) return;

  this.infoenfantService.updateUserPhoto(
    this.selectedFile,
    Number(this.selectedStudent.idUserStudent)
  ).subscribe({
    next: (response: any) => {
      this.alertService.showSuccess({
        title: 'Succès',
        message: response.response?.msg || 'Photo mise à jour avec succès !'
      });
      this.selectedFile = null;
      setTimeout(() => this.onStudentSelected(this.selectedStudent!), 500);
    },
    error: (err: any) => {
      console.error('Erreur upload photo:', err);
      const msg = err.error?.msg || err.message || 'Erreur lors de la mise à jour de la photo';
      this.alertService.showError({ title: 'Erreur', message: msg });
    }
  });
}


onSubmitProfile(): void {
  if (!this.selectedStudent) return;

  this.alertService.showConfirmation({
    title: 'Confirmation',
    message: 'Êtes-vous sûr de vouloir enregistrer ces modifications du profil ?'
  }).then((isConfirmed) => {
    if (!isConfirmed || !this.selectedStudent) return;

    const fullName = (this.profileForm.nameStudent || '').trim();
    let nom = '';
    let prenom = '';

    if (fullName.includes(' ')) {
      const parts = fullName.split(/\s+/);
      nom = parts.shift() || '';
      prenom = parts.join(' ');
    } else {
      nom = fullName;
      prenom = '';
    }

    // ✅ Utilisation de "!" pour dire à TypeScript : je sais que c’est défini
    const idStudent = Number(this.selectedStudent!.idStudent);

    if (isNaN(idStudent)) {
      console.error('ID étudiant invalide:', this.selectedStudent!.idStudent);
      return;
    }

    this.infoenfantService.updateStudentProfile(
      idStudent,
      nom,
      prenom,
      this.profileForm.birthDate || '',
      this.profileForm.birthPlace || '',
      this.profileForm.arabicName || '',
      this.profileForm.admissionNumber || '',
      this.profileForm.fatherPhone || '',
      this.profileForm.fatherPhone2 || '',
      [] // lstAllergie vide par défaut
    ).subscribe({
      next: (res) => {
        this.alertService.showSuccess({
          title: 'Succès',
          message: res?.response?.msg || 'Profil mis à jour avec succès'
        });
        this.onStudentSelected(this.selectedStudent!);
      },
      error: (err) => {
        console.error('Erreur mise à jour du profil:', err);
        this.alertService.showError({
          title: 'Erreur',
          message: 'Erreur lors de la mise à jour du profil.'
        });
      }
    });
  });
}


onSubmitSchoolData(): void {
  // Vérifie qu’un élève est sélectionné
  if (!this.selectedStudent) return;

  this.alertService.showConfirmation({
    title: 'Confirmation',
    message: 'Êtes-vous sûr de vouloir enregistrer ces données scolaires ?'
  }).then((isConfirmed) => {
    if (!isConfirmed) return;

    // Construction de l'objet ecoleData selon l’API
    const ecoleData = {
      oldJardinKind: this.schoolForm.oldJardinKind ? 'oui' : 'non',
      haveBeenToPreparatoire: this.schoolForm.haveBeenToPreparatoire ? 'oui' : 'non',
      transfered: this.schoolForm.transfered ? 'oui' : 'non',
      transfertReason: this.schoolForm.transfertReason || '',
      niveautransfer: this.schoolForm.startingLevel || '',
      allowTripPermPar: this.schoolForm.allowTripPermPar ? 'oui' : 'non',
      allowTripOcaPar: this.schoolForm.allowTripOcaPar ? 'oui' : 'non',

      firstName: this.familyForm?.emergencyContacts?.[0]?.firstName || '',
      lastName: this.familyForm?.emergencyContacts?.[0]?.lastName || '',
      childRelative: this.familyForm?.emergencyContacts?.[0]?.childRelative || '',
      mobile: this.familyForm?.emergencyContacts?.[0]?.mobile || '',
      emmergencyCall: this.familyForm?.emergencyContacts?.[0]?.emmergencyCall ? 'true' : 'false',
      takeAfterSchool: this.familyForm?.emergencyContacts?.[0]?.takeAfterSchool ? 'true' : 'false',

      firstName1: '',
      lastName1: '',
      childRelative1: '',
      mobile1: '',
      emmergencyCall1: '',
      takeAfterSchool1: ''
    };

    // ✅ Conversion sécurisée en number
    const idStudent = Number(this.selectedStudent!.idStudent);
    const id = Number(this.familyForm?.emergencyContacts?.[0]?.id || 0);

    // ✅ Appel API
    this.infoenfantService.updateEcole(idStudent, id, ecoleData).subscribe({
      next: () => {
        this.alertService.showSuccess({
          title: 'Succès',
          message: 'Données scolaires mises à jour avec succès !'
        });
        this.loadSchoolData(); // Rafraîchit les données affichées
      },
      error: () => {
        this.alertService.showError({
          title: 'Erreur',
          message: 'Erreur lors de la mise à jour des données scolaires.'
        });
      }
    });
  });
}


onSubmitFamilyData(): void {
  if (!this.selectedStudent) return;

  this.alertService.showConfirmation({
    title: 'Confirmation',
    message: 'Êtes-vous sûr de vouloir enregistrer ces données familiales ?'
  }).then((isConfirmed) => {
    if (isConfirmed) {
      // On accède directement à l’objet familyForm, sans .value
      const formValue = this.familyForm;

      const familyData = {
        childrenNumber: formValue.childrenNumber,
        childRank: formValue.childRank,
        liveWithParents: formValue.liveWithParents,
        otherGuardian: formValue.otherGuardian,

        // Données père
        pfirstName: formValue.father.firstName,
        plastName: formValue.father.lastName,
        padress: formValue.father.adress,
        planguParle: formValue.father.languParle,
        pfamilyStuation: formValue.father.familyStuation,
        pprofession: formValue.father.profession,
        padressMail: formValue.father.adressMail,
        peMId: formValue.father.id || '',
        pmobile: formValue.father.mobile,

        // Données mère
        mfirstName: formValue.mother.firstName,
        mlastName: formValue.mother.lastName,
        madress: formValue.mother.adress,
        mlanguParle: formValue.mother.languParle,
        mfamilyStuation: formValue.mother.familyStuation,
        mprofession: formValue.mother.profession,
        madressMail: formValue.mother.adressMail,
        meMId: formValue.mother.id || '',
        mmobile: formValue.mother.mobile
      };

      const idStudent = Number(this.selectedStudent?.idStudent);
      if (!idStudent) return;

      this.infoenfantService.updateFamille(idStudent, familyData).subscribe({
        next: () => {
          this.alertService.showSuccess({
            title: 'Succès',
            message: 'Données familiales mises à jour avec succès !'
          });
          this.loadFamilyData();
        },
        error: () => {
          this.alertService.showError({
            title: 'Erreur',
            message: 'Erreur lors de la mise à jour des données familiales.'
          });
        }
      });
    }
  });
}


  /** Charger les infos école */
loadSchoolData(): void {
  if (!this.selectedStudent) return;
  const studentId = this.selectedStudent.idStudent;

  this.infoenfantService.getEcoleByStudentId(studentId).subscribe({
    next: (res) => {
      if (res && res.response) {
        const data = res.response;

        this.schoolForm.oldJardinKind = data.oldJardinKind || false;
        this.schoolForm.haveBeenToPreparatoire = data.haveBeenToPreparatoire || false;
        this.schoolForm.transfered = data.transfered || false;
        this.schoolForm.startingLevel = data.startingLevel || '';
        this.schoolForm.transfertReason = data.transfertReason || '';
        this.schoolForm.allowTripOcaPar = data.allowTripOcaPar || false;
        this.schoolForm.allowTripPermPar = data.allowTripPermPar || false;

        this.cd.detectChanges();
      } else {
        console.warn('Aucune donnée trouvée pour cet étudiant.');
      }
    },
    error: (err) => {
      console.error('Erreur lors de la récupération de l’école:', err);
    },
  });
}


loadFamilyData(): void {
  if (!this.selectedStudent) return;
  const studentId = this.selectedStudent.idStudent.toString();

  // --- 1️⃣ Charger les contacts familiaux principaux et urgences ---
  this.infoenfantService.getFamilleByStudentId(studentId).subscribe({
    next: (res) => {
      if (res && Array.isArray(res.response)) {
        const contacts: any[] = res.response;

        // Trouver les contacts père, mère et autre
        const fatherContact = contacts.find(c =>
          /p(è|e)re/i.test(c.childRelative || '')
        );
        const motherContact = contacts.find(c =>
          /m(è|e)re/i.test(c.childRelative || '')
        );
        const otherContact = contacts.find(c =>
          !/p(è|e)re/i.test(c.childRelative || '') &&
          !/m(è|e)re/i.test(c.childRelative || '')
        );

        // Charger les données du père
        if (fatherContact) {
          this.familyForm.father = {
            id: fatherContact.id || '',
            firstName: fatherContact.firstName || '',
            lastName: fatherContact.lastName || '',
            adress: fatherContact.adress || '',
            languParle: fatherContact.languParle || '',
            familyStuation: fatherContact.familyStuation || '',
            profession: fatherContact.profession || '',
            adressMail: fatherContact.adressMail || '',
            mobile: fatherContact.mobile || ''
          };
        }

        // Charger les données de la mère
        if (motherContact) {
          this.familyForm.mother = {
            id: motherContact.id || '',
            firstName: motherContact.firstName || '',
            lastName: motherContact.lastName || '',
            adress: motherContact.adress || '',
            languParle: motherContact.languParle || '',
            familyStuation: motherContact.familyStuation || '',
            profession: motherContact.profession || '',
            adressMail: motherContact.adressMail || '',
            mobile: motherContact.mobile || ''
          };
        }

        // Charger les autres contacts d'urgence
        this.familyForm.emergencyContacts = otherContact
          ? [otherContact]
          : [{} as any];

        this.cd.detectChanges();
      } else {
        console.warn('Aucun contact trouvé pour cet élève');
      }
    },
    error: (err) => {
      console.error('Erreur lors de la récupération de la famille:', err);
    },
  });

  // --- 2️⃣ Charger les infos secondaires (rang, nombre d’enfants, etc.) ---
  this.infoenfantService.getFamille2ByStudentId(studentId).subscribe({
    next: (res2) => {
      if (res2 && res2.response) {
        const data = res2.response;

        this.familyForm.childrenNumber = data.childrenNumber ?? '';
        this.familyForm.childRank = data.childRank ?? '';
        this.familyForm.liveWithParents = !!data.liveWithParents;
        this.familyForm.otherGuardian = data.otherGuardian || '';
      } else {
        console.warn('Aucune donnée famille2 trouvée');
      }

      this.cd.detectChanges();
    },
    error: (err2) => {
      console.error('Erreur lors de la récupération de la famille 2:', err2);
    },
  });
}

}
